import Vue from "vue";
import VueRouter from "vue-router";
import { View } from "../plugins/view";
import authGuard from "@/auth/auth-guard";
import {adminGuard, isAppAdmin} from "@/auth/auth-admin";
import store from "@/store";

Vue.use(VueRouter);
const routes = [
  {
    path: "*",
    name: "NotFound",
    meta: { title: "404 - Page Not Found" },
    hidden: true,
    component: View("404")
  },
  {
    path: "/",
    name: "Service List",
    icon: "mdi-home",
    meta: { title: "VISP - Home", requiresAuth: true },
    component: View("ServiceList"),
    beforeEnter: authGuard //NavGuard
  },
  {
    path: "/service-details/:acct",
    name: "Service Details",
    icon: "mdi-information-outline",
    meta: {
      title: "VISP - Service Details",
      requiresAuth: true,
      requiresService: true
    },
    component: View("ServiceDetails"),
    beforeEnter: authGuard //NavGuard
  },
  {
    path: "/auth-logs",
    name: "Auth Logs",
    icon: "mdi-playlist-check",
    meta: {
      title: "VISP - Auth Logs",
      requiresAuth: true,
      requiresService: true
    },
    component: View("AuthLogs"),
    beforeEnter: authGuard //NavGuard
  },
  // {
  //   path: "/audit-logs",
  //   name: "Audit Logs",
  //   icon: "mdi-file-document-edit-outline",
  //   meta: {
  //     title: "VISP - Audit Logs",
  //     requiresAuth: true,
  //     requiresService: true
  //   },
  //   component: View("AuditLogs"),
  //   beforeEnter: authGuard //NavGuard
  // },
  {
    path: "/auth",
    name: "Auth",
    hidden: true,
    meta: { title: "auth callback", requiresAuth: false },
    component: View("Auth")
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    hidden: true,
    meta: { title: "unauthorised", requiresAuth: false },
    component: View("Unauthorized")
  },
  {
    path: "/wholesaler-list",
    name: "Wholesaler List",
    icon: "mdi-alpha-w",
    meta: { title: "Wholesaler", requiresAuth: true, role: "VispAdmin" },
    component: View("WholesalerList"),
    beforeEnter: adminGuard
  },
  {
    path: "/import-rundeck",
    name: "Import Rundeck",
    icon: "mdi-arrow-down-bold-box",
    meta: { title: "Import Rundeck", requiresAuth: true, role: "VispAdmin" },
    component: View("ImportRundeck"),
    beforeEnter: adminGuard
  },
  {
    path: "/ip-address",
    name: "Manage Ip Address",
    icon: "mdi-file-document-edit-outline",
    meta: { title: "Manage Ip Address", requiresAuth: true, role: "VispAdmin" },
    component: View("IpAddressList"),
    beforeEnter: adminGuard
  }
];

let router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;
